var exports = {
  "kL": "x1cb7f6e3--98eeff--container",
  "nL": "x1cb7f6e3--98eeff--numbers",
  "p": "x1cb7f6e3--98eeff--numbers-block",
  "x6": "x1cb7f6e3--98eeff--button",
};

module.exports = exports;
